import classes from './Games.module.scss';
import Image from 'next/image';
import BadgeList from '../../molecules/badgeList/BadgeList';

const Games = (props) => {
    if (!props) return null;

    const { 0: site_content, 1: site_image } = props;
    const gameTypes = props[2].game_type_list;
    const { game_features, tags_title } = props[3];

    return (
        <div className={classes.oGames}>
            <div className={`${classes.oContainer} container`}>
                <div className={`row`}>
                    <div className={`${classes.oBodyBlock} col-12 col-md-6`}>
                        <div className={`${classes.oTextBlock} fontRTL`}>
                            <h3 className={`${classes.aTitle} fnt30f`}>
                                {site_content.site_header}
                            </h3>
                            <div className={`${classes.aText} fnt18f fnt-pm fontRTL`}>
                                <p>{site_content.site_description}</p>
                            </div>
                        </div>
                    </div>
                    <figure className={`${classes.oImageBlock} col-12 col-md-6`}>
                        <Image
                            src={site_image?.image?.data?.attributes.url}
                            alt={site_image?.image?.data?.attributes.title}
                            height={site_image?.image?.data?.attributes.height}
                            width={site_image?.image?.data?.attributes.width}
                            className={classes.aImage}
                            aria-hidden="true"
                            layout="responsive"
                        />
                    </figure>
                </div>
                <div className={`row`}>
                    <div className={`${classes.oCardRegion} col-12`}>
                        {gameTypes.map((card) => (
                            <div className={classes.oCard} key={card.id}>
                                <figure className={classes.mCardImage}>
                                    <Image
                                        src={card?.image?.data?.attributes?.url}
                                        alt={card?.image?.data?.attributes?.alternativeText}
                                        height={card?.image?.data?.attributes?.height}
                                        width={card?.image?.data?.attributes?.width}
                                        className={classes.aImage}
                                        aria-hidden="true"
                                        layout="responsive"
                                    />
                                </figure>
                                <div className={classes.mCardBody}>
                                    <p className={`${classes.aText} fnt12 fnt-pm`}>{card.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={`row`}>
                    <div className={`${classes.oBadgeWrapper} col-12`}>
                        <BadgeList title={tags_title} data={game_features} />
                    </div>
                </div>
            </div>
            <figure className={classes.oBackground}>
                <svg
                    width="855"
                    height="709"
                    viewBox="0 0 855 709"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    className={classes.aSvg}
                >
                    <path
                        d="M391.445 104.399C592.937 -75.4488 829.001 31.6415 865 31.6409V621.91C312.949 789.46 106.958 675.71 54.4605 607.563C29.6816 575.397 -30.5346 487.152 18.9632 408.245C68.4609 329.337 257.452 421.567 289.451 330.362C315.049 257.398 329.448 159.737 391.445 104.399Z"
                        fill="url(#paint0_linear_1065_7369)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1065_7369"
                            x1="459.516"
                            y1="250.685"
                            x2="925.462"
                            y2="153.886"
                            gradientUnits="userSpaceOnUse"
                            className={classes.aSvgDesk}
                            preserveAspectRatio="none"
                        >
                            <stop stopColor="#D83A5B" />
                            <stop offset="1" stopColor="#9A1932" />
                        </linearGradient>
                    </defs>
                </svg>
            </figure>
        </div>
    );
};

export default Games;
